<script lang="ts">
	import type { IRates } from 'components/Converter/types';

	export let dark: boolean;
	export let selectedValue: IRates;
	export let amount: number;
	export let onChange: (e: Event) => void;
	export let isInputOnFocus: boolean = false;
</script>

<div class={`calculator center ${$$props.class || ''}`} class:dark class:focus={isInputOnFocus}>
	<div class="label center">
		<slot />
		<div class="wrapper">
			<div class="scale-wrapper center">
				<p class="chosen-scale">
					{selectedValue.currency?.length > 3
						? selectedValue.currency.slice(0, 3)
						: selectedValue.currency}
				</p>
			</div>
		</div>
	</div>
	<input
		class="input"
		type="number"
		aria-label={`${$$props.label}`}
		name={`${$$props.label} converter`}
		bind:value={amount}
		on:input={(e) => {
			onChange(e);
		}}
		on:focus={() => (isInputOnFocus = true)}
		on:blur={() => (isInputOnFocus = false)}
	/>
</div>

<style lang="scss">
	@import 'CurrencyRow';
</style>
